<template>
  <div
    v-if="id"
  >
    <div
     v-if="!newsletterId"
    >
      <h2>Email Recipient #{{ id }}</h2>

      <email-nav />
    </div>

    <table
      class="table"
    >
      <tr>
        <td>
          Delivery Status
        </td>
        <td>
          <email-recipient-status-badge
            :status="status"
            :statusType="statusType"
            v-if="status"
          />
        </td>
      </tr>
      <tr
        v-if="!this.newsletterId"
      >
        <td>
          Mailer Method
        </td>
        <td>
          {{ mailer_method }}
        </td>
      </tr>
      <tr
        v-if="!this.newsletterId"
      >
        <td>
          UUID
        </td>
        <td>
          {{ uuid }}
        </td>
      </tr>
      <tr>
        <td>
          Queued At
        </td>
        <td>
          {{ this.$root.displayDateTimeFmt(queued_at) }}
        </td>
      </tr>
      <tr>
        <td>
          Relayed At
        </td>
        <td>
          {{ this.$root.displayDateTimeFmt(send_at) }}
        </td>
      </tr>
      <tr>
        <td>
          Relayed To Email Service At
        </td>
        <td>
          {{ this.$root.displayDateTimeFmt(sent_at) }}
        </td>
      </tr>
      <tr>
        <td>
          Bounced At
        </td>
        <td>
          {{ this.$root.displayDateTimeFmt(last_bounced_at) }}
          <span
            class="badge badge-danger"
            v-if="permanent_bounce"
          >
            Permanent
          </span>
        </td>
      </tr>
      <tr>
        <td>
          Server/User Complained At
        </td>
        <td>
          {{ this.$root.displayDateTimeFmt(last_complained_at) }}
        </td>
      </tr>
      <tr>
        <td>
          Delivered At
        </td>
        <td>
          {{ this.$root.displayDateTimeFmt(last_delivered_at) }}
        </td>
      </tr>
      <tr>
        <td>
          Error Count
        </td>
        <td>
          {{ error_count }}
        </td>
      </tr>
      <tr>
        <td>
          Recipient Email
        </td>
        <td
          v-if="!user_id"
        >
          {{ recipient_email }}
        </td>
        <td
          v-else
        >
          <router-link
            :to="{
              name: 'user',
              params: {
                userId: user_id
              }
            }"
          >
            {{ recipient_email }}
          </router-link>
        </td>
      </tr>
      <tr>
        <td>
          Created At
        </td>
        <td>
          {{ this.$root.displayDateTimeFmt(created_at) }}
        </td>
      </tr>
      <tr>
        <td>
          Updated At
        </td>
        <td>
          {{ this.$root.displayDateTimeFmt(updated_at) }}
        </td>
      </tr>
      <tr>
        <td
          id="email-notification"
        >
          Last AWS Email Status Notification (Debug Only)
          <button
            class="btn btn-secondary btn-small"
            v-if="last_sns"
            @click="toggleNotificationDisplay"
          >
            {{ notificationActionLbl }}
          </button>
        </td>
        <td>
          <email-recipient-notification
            :notification="last_sns"
            v-bind:showNotification="showNotification"
            v-if="last_sns"
          />
          <span
            v-if="!last_sns"
          >
            No Email Notification Available
          </span>
        </td>
      </tr>
    </table>

    <form
    >
      <div class="form-group">
        <button
          type="button"
          class="btn btn-primary form-control"
          v-on:click.prevent="dequeue"
          v-if="!sent_at"
        >
          De-queue
          <spinner size="small" v-if="loading"></spinner>
        </button>
      </div>
      <div class="form-group">
        <button
          type="button"
          class="btn btn-primary btn-block form-control"
          v-on:click.prevent="queue"
          v-if="!sent_at"
        >
          Re-queue
          <spinner size="small" v-if="loading" />
        </button>
        <button
          type="button"
          class="btn btn-primary btn-block form-control"
          v-on:click.prevent="queue"
          v-if="sent_at"
        >
          Re-Queue
          <spinner size="small" v-if="loading" />
        </button>
        <button
          type="button"
          class="btn btn-danger btn-block form-control"
          v-on:click.prevent="deleteRecipient"
        >
          Delete
          <spinner size="small" v-if="loading" />
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner'

import EmailNav from '@/components/EmailNav'
import EmailRecipientNotification from '@/components/EmailRecipientNotification'
import EmailRecipientStatusBadge from '@/components/EmailRecipientStatusBadge'

import EmailMixin from '@/mixins/EmailMixin'

import FlashStore from '@/stores/FlashStore'
import NewsletterRecipientStore from '@/stores/NewsletterRecipientStore'

export default {
  data () {
    let state = NewsletterRecipientStore.state
    state.showNotification = false

    return state
  },

  computed: {
    actionUrl () {
      return (this.newsletterId ? '/newsletters/' + this.newsletterId + '/recipients/' : '/email_recipients/') + this.recipientId
    },

    notificationActionLbl () {
      return this.showNotification ? 'Hide' : 'Show'
    },

    queueUrl () {
      return this.newsletterId ? (
        '/newsletters/' + this.newsletterId + '/queue/' + this.recipientId
      ) : (
        '/email_recipients/' + this.recipientId + '/queue/'
      )
    },

    recipientType () {
      return this.newsletterId ? 'Newsletter' : 'Email'
    },

    statusType () {
      return this.permanent_bounce ? 'Permanent' : undefined
    }
  },

  components: {
    'email-nav': EmailNav,
    'email-recipient-notification': EmailRecipientNotification,
    'email-recipient-status-badge': EmailRecipientStatusBadge,
    'spinner': Spinner
  },

  props: {
    recipientId: {
      type: [ Number, String ],
      default: undefined,
      required: true
    }
  },

  mixins: [
    EmailMixin
  ],

  mounted () {
    this.get()
  },

  methods: {
    get () {
      this.loading = true

      this.apiGet(
        this.actionUrl,
        NewsletterRecipientStore,
        true
      ).then((resp) => {
        this.$emit('loaded', NewsletterRecipientStore.state)
      })
    },

    deleteRecipient () {
      if (confirm('This will permanently delete this recipient record! Are you sure you want to continue?')) {
        this.loading = true

        this.$http.delete(
          this.apiUrl(
            this.actionUrl,
            true
          )
        ).then((resp) => {
          this.$router.push({
            name: this.relationalIdName + '_recipients',
            params: {
              [this.idName]: this.baseId
            }
          })

          FlashStore.result('This email recipient record has been deleted.')
        }, (resp) => {
          this.loading = false

          this.$parent.processErrors(resp)
        })
      }
    },

    dequeue () {
      this.loading = true

      this.$http.delete(
        this.apiUrl(
          this.queueUrl,
          true
        )
      ).then((resp) => {
        this.loading = false
        this.processSuccess(resp, NewsletterRecipientStore)
      }, (resp) => {
        this.loading = false

        this.$parent.processErrors(resp)
      })
    },

    queue () {
      this.loading = true

      this.$http.post(
        this.apiUrl(
          this.queueUrl,
          true
        )
      ).then((resp) => {
        this.loading = false
        this.processSuccess(resp, NewsletterRecipientStore)
      }, (resp) => {
        this.loading = false

        this.$parent.processErrors(resp)
      })
    },

    toggleNotificationDisplay () {
      this.showNotification = !this.showNotification
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EmailRecipient.vue